import React, { useState } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useLogout from '../../hooks/useLogout';
import Pagination from './Pagination';
import SpinnerController from '../spinnerController/Spinner';

const HistoryTable = ({ ticketDetails, setTicketDetails }) => {
    const axiosPrivate = useAxiosPrivate();
    const logout = useLogout();
    let [project, setproject] = useState(false);

    let changeProject = async (value) => {
        setTicketDetails(false);
        setproject(value);
        try {
            const response = await axiosPrivate.get(`/report/history?project=${value}`);
            if (response.data.msg) return setTicketDetails({});
            console.log(response.data);
            setTicketDetails(response.data);
        } catch (err) {
            if (err.message !== 'canceled') {
                await logout();
            }
        }
    };

    return (
        <>
            <div className='max-w-6xl flex px-10 justify-center container mx-auto pt-10'> {/* Reduced pt-32 to pt-10 */}
                <div className="table-wrp block max-h-[41rem] overflow-y-auto relative shadow-md sm:rounded-lg bg-gray-500 w-10/12">
                    <table className="w-full text-sm text-center text-gray-500">
                        <caption className="sticky top-0 p-5 text-lg font-semibold text-left text-gray-700 bg-white border-b-2 border-gray-500">
                            <div className="flex items-center">
                                <div className="pb-1">
                                    <select defaultValue={"last_ten_escalations"} id="underline_select" onChange={(e) => changeProject(e.target.value)}
                                        className="block w-48 py-2.5 px-0 w-40 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 peer">
                                        <option value="last_ten_escalations">Previous escalations</option>
                                        <option value="open_tickets">Closed tickets</option>
                                        <option value="closed_tickets">Open tickets</option>
                                    </select>
                                </div>
                            </div>
                        </caption>
                        <thead className="sticky top-[88px] text-xs text-gray-900 uppercase bg-white border-b-2 border-gray-500">
                            <tr>
                                <th scope="col" className="py-3 px-6">
                                    Index
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Ticket
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Status
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Escalated By
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Created at
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <>
                                {!ticketDetails.tickets
                                    ? <tr key="loading">
                                        <td colSpan="5" className="bg-gray-50 p-4">
                                            <div className="flex justify-center">
                                                <SpinnerController />
                                            </div>
                                        </td>
                                    </tr>
                                    : !ticketDetails.tickets.length
                                        ? <tr key="nodata">
                                            <td className="bg-gray-50 p-4" colSpan="5">No data available</td>
                                        </tr>
                                        : <>
                                            {ticketDetails.tickets.map((ticket, i) => (
                                                <tr key={i} className="bg-white text-gray-900 border-b hover:bg-myellow">
                                                    <th scope="row" className="py-4 px-6">
                                                        {i + 1}
                                                    </th>
                                                    <td className="py-4 px-6 bg-myellow font-medium font-semibold text-gray-900">
                                                        {ticket.ticket}
                                                    </td>
                                                    <td className="py-4 px-6">
                                                        {ticket.isOpened ? "Open" : "Closed"}
                                                    </td>
                                                    <td className="py-4 px-6 font-medium font-semibold text-gray-900">
                                                        {ticket.email}
                                                    </td>
                                                    <td className="py-4 px-6">
                                                        {new Date(ticket.createdAt).toLocaleString()}
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                }
                            </>
                        </tbody>
                    </table>
                </div>
            </div>
            {ticketDetails?.tickets?.length > 0 &&
                <Pagination ticketsLength={ticketDetails?.tickets?.length} project={project} />
            }
        </>
    );
}

export default HistoryTable;
